import { topScripts, TopScripts } from "./head";
import { PreloadResources, PreconnectResources } from "./script-preload";
import LazyHydrate from "./lazy-hydrate";
var canUseDOM = typeof document !== "undefined";
var satellite = canUseDOM ? window._satellite : {
    track: function() {}
};
// assuming that this function can be called by either the app or the vendor loading code in any order
export var pageLoadComplete = function(_satellite) {
    if (_satellite === void 0) _satellite = satellite;
    if (!_satellite) return;
    if (window.launchVendorsLoaded) {
        _satellite.track("page-load-complete");
    } else {
        window.addEventListener("launch-vendors-loaded", function _listener() {
            window.launchVendorsLoaded = true;
            _satellite.track("page-load-complete");
            window.removeEventListener("launch-vendors-loaded", _listener, true);
        }, true);
    }
};
export { topScripts, TopScripts, PreloadResources, PreconnectResources, LazyHydrate };
